module.exports = __webpack_public_path__ + "9e9c713a411b3e14f3c203ebe5a831f9.svg";